var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('x-input',_vm._b({attrs:{"name":_vm.name,"labelSize":_vm.labelSize,"text":_vm.text,"invalidMessage":_vm.invalidMessage,"description":_vm.description,"state":_vm.isValid},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}},'x-input',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }